<template>
  <div>
    <div v-if="dataMedicals && dataMedicals.length > 0" class="row" style="border: 1px solid #e0e0e0">
      <div class="d-flex col-12 justify-content-between px-3 py-2" style="background-color: #f8f8fb;">
        <div><h5 class="text-list-locomo-7 mb-1">履歴照会</h5></div>
      </div>
      <div class="p-0">
        <Spliter :initialLeftWidth="250">
          <template #left>
            <div class="col-12 px-1">
              <div class="mt-2 px-1">
                <b-button class="w-lg btn-edit" :disabled="listIds.length === 0" :class="{'bg-disabled': listIds.length === 0}" @click="exportExcel()">Excel出力</b-button>
              </div>
              <div class="table-responsive mt-2 mb-0 scroll" :style="{maxHeight: isExpand ? '65vh': '50vh'}">
                <vue-loadmore :on-refresh="onRefresh" :on-loadmore="onLoad" loading-text="読み込み中" :finished="finished" finished-text=" ">
                  <table class="table align-middle mb-0">
                    <tbody>
                      <tr v-for="(medical, index) in dataMedicals" :key="index" @click="(clickIndex = index), handlerData()"
                        style="cursor: pointer">
                        <td class="pe-1" :class="{ 'bg-active-locomo': index === clickIndex }">
                          <input class="form-check-input" type="checkbox" @click="checkedLocomo(medical.uuid)"
                            id="formCheckRight2" :checked="isChecked(medical.uuid)" style="font-size: 24px; margin: 0">
                        </td>
                        <td width="100%" :class="{ 'bg-active-locomo': index === clickIndex }" class="px-1">
                          <h5 class="text-list-locomo-7 mb-0">
                            {{ medical.created_at | fomatDate2 }}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </vue-loadmore>
              </div>
            </div>
          </template>

          <template #right>
            <div class="col-12 px-3" style="margin-bottom: 20px;">
              <div class="mt-2 mb-4 d-flex justify-content-between">
                <h5 class="text-list-locomo-7">詳細</h5>
                <div>
                  <button v-if="edit" class="w-lg btn-cancel" @click="cancel">キャンセル</button>
                  <button v-if="(role === 'admin' && !edit) || (role === 'hospital' && !edit && time_out_facility === null)" class="w-lg btn-edit" @click="toEdit">編集</button>
                  <button v-if="['admin', 'hospital'].includes(role) && edit" class="w-lg btn-edit" @click="editInfo">保存</button>
                </div>
              </div>
              <div class="row scroll" :style="{maxHeight: isExpand ? '60vh': '50vh'}" v-for="(medical, index) in dataEdit" :key="index">
                <div class="col-md-6" v-if="index === clickIndex">
                  <div>
                    <h5 v-if="edit" class="text-muted mt-4">
                      身長
                      <span class="require">必須</span>
                    </h5>
                    <h5 v-else class="text-muted mt-4">身長</h5>
                    <div v-if="edit" class="d-flex">
                      <b-form-input class="w-70 text-color" @keypress="isNumber($event)" v-model="medical.height"
                        maxlength="255"></b-form-input>
                      <span class="mx-2 my-auto text-des">cm</span>
                    </div>
                    <h4 v-else class="text-color">{{ medical.height ? medical.height + '（cm ）' : "" }}</h4>
                    <div v-if="edit && medical.height && (medical.height >= 300 || medical.height <= 0)" class="col-8">
                      <span class="text-danger">1から299までの整数を入力する必要があります。もう一度やり直してください。</span>
                    </div>
                  </div>
                  <div>
                    <h5 v-if="edit" class="text-muted mt-4">
                      体重
                      <span class="require">必須</span>
                    </h5>
                    <h5 v-else class="text-muted mt-4">体重</h5>
                    <div v-if="edit" class="d-flex">
                      <b-form-input class="w-70 text-color" @keypress="isNumber($event)" v-model="medical.weight"
                        maxlength="255"></b-form-input>
                      <span class="mx-2 my-auto text-des">kg</span>
                    </div>
                    <h4 v-else class="text-color">
                      {{ medical.weight ? medical.weight + '（kg ）' : "" }}
                    </h4>
                    <div v-if="edit && medical.weight && (medical.weight >= 300 || medical.weight <= 0)" class="col-8">
                      <span class="text-danger">1から299までの整数を入力する必要があります。もう一度やり直してください。</span>
                    </div>
                  </div>
                  <div>
                    <h5 class="text-muted mt-4">BMI</h5>
                    <h4 class="text-color">
                      {{ calculateBmi(medical.weight, medical.height) }}
                    </h4>
                  </div>
                  <div>
                    <h5 class="text-muted mt-4">肥満の判定</h5>
                    <h4 class="text-color">{{ desBmi(medical.weight, medical.height) }}</h4>
                  </div>
                  <div>
                    <h5 v-if="edit" class="text-muted mt-4">
                      血圧
                    </h5>
                    <h5 v-else class="text-muted mt-4">血圧</h5>
                    <div v-if="edit">
                      <div class="d-flex">
                        <b-form-input class="w-70 text-color" @keypress="isNumber($event)" @input="updateLowerPressure"
                          :value="lowerPressure(medical.blood_pressure)" maxlength="10" placeholder="下の血圧"></b-form-input>
                        <span class="mx-2 my-auto text-des">~</span>
                      </div>
                      <div class="d-flex">
                        <b-form-input class="w-70 text-color" @keypress="isNumber($event)" @input="updateUpperPressure"
                          :value="upperPressure(medical.blood_pressure)" maxlength="10" placeholder="上の血圧"></b-form-input>
                        <span class="mx-2 my-auto text-des">mmHg</span>
                      </div>
                    </div>
                    <h4 v-else class="text-color">
                      {{ medical.blood_pressure ? medical.blood_pressure + '（mmhg ）' : "回答なし" }}
                    </h4>
                    <div
                      v-if="edit && (bloodPressureSystolicNew && (bloodPressureSystolicNew >= 300 || bloodPressureSystolicNew <= 0))
                        || (bloodPressureDiastolicNew && (bloodPressureDiastolicNew >= 300 || bloodPressureDiastolicNew <= 0))"
                      class="col-8">
                      <span class="text-danger">1から299までの整数を入力する必要があります。もう一度やり直してください。</span>
                    </div>
                  </div>
                  <div>
                    <h5 v-if="edit" class="text-muted mt-4">
                      脈拍
                    </h5>
                    <h5 v-else class="text-muted mt-4">脈拍</h5>
                    <div v-if="edit" class="d-flex">
                      <b-form-input class="w-70 text-color" @keypress="isNumber($event)" v-model="medical.pulsation"
                        maxlength="255"></b-form-input>
                      <span class="mx-2 my-auto text-des">bpm</span>
                    </div>
                    <h4 v-else class="text-color">{{ medical.pulsation ? medical.pulsation + '（bpm ）' : "回答なし" }}</h4>
                  </div>
                  <div>
                    <h5 v-if="edit" class="text-muted mt-4">
                      症状
                      <span class="require">必須</span>
                    </h5>
                    <h5 v-else class="text-muted mt-4">症状</h5>
                    <b-form-group v-if="edit" class="mb-3">
                      <select v-model="medical.symptom" class="w-70 text-color form-control">
                        <option v-for="symptom in SymptomsData" :key="symptom.value" :value="symptom.value">
                          {{ symptom.label }}
                        </option>
                      </select>
                    </b-form-group>
                    <h4 v-else class="text-color">{{ medical.symptom ? medical.symptom : "回答なし" }}</h4>
                  </div>
                  <div v-if="medical.symptom && medical.symptom != 'なし'">
                    <h5 v-if="edit" class="text-muted mt-4">
                      症状は何ヶ月前から?
                      <span class="require">必須</span>
                    </h5>
                    <h5 v-else class="text-muted mt-4">症状は何ヶ月前から?</h5>
                    <div v-if="edit" class="d-flex">
                      <b-form-input class="w-70 text-color" type="text" v-model="medical.when" maxlength="255"></b-form-input>
                      <span class="mx-2 my-auto text-des">ケ月前</span>
                    </div>
                    <h4 v-else class="text-color">{{ medical.when ? medical.when + "（ケ月前）" : "回答なし" }}</h4>
                  </div>
                </div>
                <div class="col-md-6" v-if="index === clickIndex">
                  <div>
                    <h5 v-if="edit" class="text-muted mt-4">
                      動悸・胸の痛み
                      <span class="require">必須</span>
                    </h5>
                    <h5 v-else class="text-muted mt-4">動悸・胸の痛み</h5>
                    <b-form-group v-if="edit" class="mb-3">
                      <select v-model="selectPalpitation" class="w-70 text-color form-control">
                        <option value="あり">あり</option>
                        <option value="なし">なし</option>
                      </select>
                    </b-form-group>
                    <h4 v-else class="text-color">
                      {{ medical.palpitation ? "あり" : "なし" }}
                    </h4>
                  </div>
                  <div>
                    <h5 class="text-muted mt-4">特記事項</h5>
                    <b-form-input v-if="edit" class="w-70 text-color" type="text" v-model="medical.special"
                      maxlength="255"></b-form-input>
                    <h4 v-else class="text-color">
                      {{ medical.special ? medical.special : "回答なし" }}
                    </h4>
                  </div>
                  <div>
                    <h5 v-if="edit" class="text-muted mt-4">
                      指摘・治療中の病気
                      <span class="require">必須</span>
                    </h5>
                    <h5 v-else class="text-muted mt-4">指摘・治療中の病気</h5>
                    <b-form-group v-if="edit" class="mb-3">
                      <select v-model="medical.diseases" class="w-70 text-color form-control">
                        <option v-for="disease in DiseasesData" :key="disease.value" :value="disease.value">
                          {{ disease.value }}
                        </option>
                      </select>
                    </b-form-group>
                    <h4 v-else class="text-color">
                      {{ medical.diseases ? medical.diseases : "回答なし" }}
                    </h4>
                  </div>

                  <div>
                    <h5 v-if="edit" class="text-muted mt-4">
                      過去の病歴
                      <span class="require">必須</span>
                    </h5>
                    <h5 v-else class="text-muted mt-4">過去の病歴</h5>
                    <b-form-input v-if="edit" class="w-70 text-color" type="text" v-model="medical.past_medical_history"
                      maxlength="255"></b-form-input>
                    <h4 v-else class="text-color">
                      {{ medical.past_medical_history ? medical.past_medical_history : "回答なし" }}
                    </h4>
                  </div>
                  <div>
                    <h5 class="text-muted mt-4">家族親族の病気</h5>
                    <b-form-group v-if="edit" class="mb-3">
                      <select v-model="medical.family_relative" class="w-70 text-color form-control">
                        <option v-for="relative in Illness_of_family_membersData" :key="relative.value"
                          :value="relative.value">
                          {{ relative.value }}
                        </option>
                      </select>
                    </b-form-group>
                    <h4 v-else class="text-color">
                      {{ medical.family_relative ? medical.family_relative : "回答なし" }}
                    </h4>
                  </div>
                  <div>
                    <h5 class="text-muted mt-4">現在、飲んでいるお薬</h5>
                    <b-form-input v-if="edit" class="w-70 text-color" type="text" v-model="medical.medication_taking"
                      maxlength="255"></b-form-input>
                    <h4 v-else class="text-color">
                      {{
                        medical.medication_taking ? medical.medication_taking : "回答なし"
                      }}
                    </h4>
                  </div>
                  <div>
                    <h5 class="text-muted mt-4">喫煙 (本/日)</h5>
                    <div v-if="edit" class="d-flex">
                      <b-form-input class="w-70 text-color" type="text" v-model="medical.smoking"
                        maxlength="255"></b-form-input>
                      <span class="mx-2 my-auto text-des">本</span>
                    </div>
                    <h4 v-else class="text-color">
                      {{ medical.smoking ? medical.smoking + "本 / 1日" : "回答なし" }}
                    </h4>
                  </div>
                  <div>
                    <h5 class="text-muted mt-4">飲酒 (合/日)</h5>
                    <div v-if="edit" class="d-flex">
                      <b-form-input class="w-70 text-color" type="text" v-model="medical.drinking"
                        maxlength="255"></b-form-input>
                      <span class="mx-2 my-auto text-des">合</span>
                    </div>
                    <h4 v-else class="text-color">
                      {{ medical.drinking ? medical.drinking + "合/ 1日" : "回答なし" }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Spliter>
      </div>
    </div>

    <div v-else class="undefine">
      <img src="@/assets/images/no-data.jpg" alt="" />
      <div class="mt-3">詳細データはありません。</div>
    </div>
  </div>
</template>

<script>
import { filter } from "../../helpers/Vue-Filter";
import { hospitalMethods } from "@/state/helpers";
import { hospitalComputed } from "@/state/helpers";
import { userMethods, userComputed } from "@/state/helpers";
import { getProfile } from "../../helpers/Auth";
import api from "@/api"
import { SymptomsData, DiseasesData, Illness_of_family_membersData } from "../../constant";
import moment from 'moment';
import Spliter from "./spliter.vue";
// import Multiselect from "vue-multiselect";

export default {
  filters: {
    ...filter,
  },
  components: {Spliter},
  props: ['isExpand'],
  data() {
    return {
      clickIndex: 0,
      loaderDetail: false,
      uuidArr: [],
      role: getProfile().role.name,
      facility_id: getProfile().facility?.id,
      edit: false,
      dataEdit: [],
      selectPalpitation: "",
      listIds: [],
      flagPDFAll: false,

      list: [],
      page: 1,
      finished: false,
      bloodPressureSystolic: '',
      bloodPressureDiastolic: '',
      bloodPressureSystolicNew: '',
      bloodPressureDiastolicNew: '',
      SymptomsData,
      DiseasesData,
      Illness_of_family_membersData,
      userInFor: [],
      time_out_facility: '',
      dataMedicals: [],
      pagination: ""
    };
  },

  watch: {
    dataMedicals: {
      async handler() {
        if (this.dataMedicals && this.dataMedicals.length > 0) {
          this.dataEdit = JSON.parse(JSON.stringify(this.dataMedicals)) || [];
        }
      },
    },
    clickIndex(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.cancel();
      }
    }
  },

  async created() {
    this.userInFor = this.role === "admin" ? await api.userGetById(this.$route.params.id) : await api.getPatientById(this.$route.params.id, this.facility_id);
    this.time_out_facility = this.role === "admin" ? '' : this.isLastFacilityTimeout(this.userInFor.data.join_facility)

    const res = await api.getDataMedical(this.role, this.userInFor.data?.medical_uuid,'', this.time_out_facility,)
    if (res) {
      const data = JSON.parse(JSON.stringify(res)) || [];
      this.dataEdit = data
      this.dataMedicals = data.data.data;
      this.pagination = data.data.meta;
    }
  },

  mounted() {
    this.fetchPage();
  },

  computed: {
    ...hospitalComputed,
    ...userComputed,
  },

  methods: {
    ...hospitalMethods,
    ...userMethods,

    isLastFacilityTimeout(joinFacility) {
      if (joinFacility == null) return null;
      const facilities = JSON.parse(joinFacility);
      if (joinFacility.length === 0) return null;
      const lastFacility = facilities[facilities.length - 1];

      return lastFacility.time_out;
    },

    isNumber(event) {
      const charCode = event.charCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },

    lowerPressure(bloodPressure) {
      if (!bloodPressure) return '';
      this.bloodPressureSystolic = parseInt(bloodPressure.split('/')[0].trim(), 10);
      return this.bloodPressureSystolic;
    },

    upperPressure(bloodPressure) {
      if (!bloodPressure) return '';
      this.bloodPressureDiastolic = parseInt(bloodPressure.split('/')[1].trim(), 10);
      return this.bloodPressureDiastolic;
    },

    updateLowerPressure(newValue) {
      this.bloodPressureSystolicNew = newValue
    },

    updateUpperPressure(newValue) {
      this.bloodPressureDiastolicNew = newValue
    },

    desBmi(weight, height) {
      const bmi = this.calculateBmi(weight, height)
      if (bmi < 18.5) {
        return ("低体重(痩せ型)");
      } else if (bmi >= 18.5 && bmi < 25) {
        return ("普通体重");
      } else if (bmi >= 25 && bmi < 30) {
        return ("肥満（１度）");
      } else if (bmi >= 30 && bmi < 35) {
        return ("肥満（２度）");
      } else if (bmi >= 35 && bmi < 40) {
        return ("肥満（３度）");
      } else {
        return ("肥満（４度）");
      }
    },

    calculateBmi(weight, height) {
      if (weight && height && weight > 0 && height > 0) {
        const bmi = (parseFloat(weight) / parseFloat((height * height) / 10000)).toFixed(2);
        return bmi
      } else {
        return 0;
      }
    },

    onRefresh(done) {
      this.list = [];
      this.page = this.page;
      this.finished = false;
      this.fetchPage();

      done();
    },

    async onLoad(done) {
      if (this.page <= this.pagination.last_page) {
        this.loadMore();
        const res = await api.getDataMedical(this.role, this.userInFor.data?.medical_uuid,this.page , this.time_out_facility,)
        if(res){
          const data = JSON.parse(JSON.stringify(res)) || [];
          this.dataMedicals = this.dataMedicals.concat(data.data.data);
        }
        this.page
      } else {
        // all data loaded
        this.finished = true;
      }
      done();
    },

    fetchPage() {
      for (let i = 0; i <= this.pagination.last_page; i++) {
        // this.list.push(this.list.length + 1);
      }
    },

    loadMore() {
      this.$emit("loadMoreMedical");
      this.page++;
    },

    handlerData() {
      if (this.dataMedicals && this.dataMedicals.length > 0) {
        this.selectPalpitation = this.dataMedicals[this.clickIndex].palpitation
          ? "あり"
          : "なし";
      }
    },

    checkedLocomo(id) {
      const index = this.listIds.findIndex(function (item) {
        return item.indexOf(id) !== -1;
      });
      if (index >= 0) {
        this.listIds.splice(index, 1);
      } else {
        this.listIds.push(id);
      }
    },

    isChecked(uuid) {
      if (this.listIds.includes(uuid)) return true;
      return false;
    },

    isCheckedAll() {
      if (this.dataMedicals.length === this.listIds.length) return true;
      return false;
    },

    selectAll($event) {
      this.flagPDFAll = $event.target.checked;
      if (!this.flagPDFAll) {
        this.listIds = [];
      } else {
        this.listIds = this.dataMedicals.map((e) => e.uuid);
      }
    },

    exportPDF() {
      if (this.flagPDFAll && this.listIds.length === this.dataMedicals.length) {
        this.$emit("exportPDFMedicals", this.dataMedicals);
      } else {
        const data = [];
        this.listIds.forEach((uuid) => {
          const index = this.dataMedicals.findIndex(function (item) {
            return item.uuid === uuid;
          });
          if (index >= 0) {
            data.push(this.dataMedicals[index]);
          }
        });

        this.$emit("exportPDFMedical", data);
      }

      this.listIds = [];
      this.flagPDFAll = false;
    },

    exportExcel() {
      const payload = {};
      payload.ids = this.listIds.toString();
      try {
        const formattedDate = moment().format('YYYYMMDD');
        api.exportHistory('medicals', payload, `身体状態_${this.userInFor.data.mobile}_${this.userInFor.data.patient_id}_${formattedDate}`);
      } catch (error) {
        console.log(error);
      }
    },

    toEdit() {
      this.edit = true;
    },

    async editInfo() {
      try {
        if (this.edit) {
          const dataWrap = JSON.parse(JSON.stringify(this.dataEdit));
          dataWrap[this.clickIndex].blood_pressure = this.bloodPressureSystolicNew && this.bloodPressureDiastolicNew ? 
                                                      `${this.bloodPressureSystolicNew} / ${this.bloodPressureDiastolicNew}` : 
                                                      this.dataMedicals[this.clickIndex].blood_pressure ? this.dataMedicals[this.clickIndex].blood_pressure : '';
          dataWrap[this.clickIndex].palpitation =
            this.selectPalpitation == "あり";
          if (
            !dataWrap[this.clickIndex].height ||
            !dataWrap[this.clickIndex].weight ||
            dataWrap[this.clickIndex].symptom.trim() === "" ||
            (dataWrap[this.clickIndex].symptom.trim() !== "なし" && !dataWrap[this.clickIndex].when) ||
            dataWrap[this.clickIndex].past_medical_history.trim() === "" ||
            dataWrap[this.clickIndex].diseases.trim() === ""
          ) {
            window.toastr.error("必須項目に入力してください");
          } else if (
            (dataWrap[this.clickIndex].height && (dataWrap[this.clickIndex].height >= 300 || dataWrap[this.clickIndex].height <= 0)) ||
            (dataWrap[this.clickIndex].weight && (dataWrap[this.clickIndex].weight >= 300 || dataWrap[this.clickIndex].weight <= 0)) ||
            (this.bloodPressureSystolicNew && (this.bloodPressureSystolicNew >= 300 || this.bloodPressureSystolicNew <= 0)) ||
            (this.bloodPressureDiastolicNew && (this.bloodPressureDiastolicNew >= 300 || this.bloodPressureDiastolicNew <= 0))
          ) {
            window.toastr.error("フィールドに入力された値が無効です");
          } else {
            if (dataWrap[this.clickIndex].symptom.trim() === "なし") {
              dataWrap[this.clickIndex].when = ''
            }
            const respon = this.role === "admin" ? await this.updateUser({
              uuid: this.userInFor.data?.medical_uuid,
              payload: dataWrap[this.clickIndex],
            }) : await api.updatePatient({
              uuid: this.userInFor.data?.medical_uuid,
              payload: dataWrap[this.clickIndex],
            })

            if (respon?.status === 200) {
              this.$emit("reloadMedical");
            }
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    cancel() {
      this.edit = false;
      if (this.dataMedicals && this.dataMedicals.length > 0) {
        this.dataEdit = JSON.parse(JSON.stringify(this.dataMedicals)) || {};
      } else {
        this.dataEdit = {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-list-locomo-7 {
  color: #404040;
  font-size: 16px;
  font-weight: 700;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

* {
  font-family: "Noto Sans JP";
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.bg-active-locomo {
  background: #b8e060;
}

.text-color {
  color: #404040;
  font-weight: 500;
  font-size: 16px;
}

.text-end {
  align-items: end;
}

.btn-edit {
  color: white;
  background-color: #8fc31f;
  border: none;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  margin-left: 6px;
}

.btn-cancel {
  color: #ff5858 !important;
  background-color: white !important;
  border: 1px solid #ff5858;
  border-radius: 4px;
  padding: 5px;
  margin-left: 10px;
}

.w-70 {
  width: 70%;
}

.require {
  background: #ff5858;
  border-radius: 14px;
  color: #f5f5f5;
  padding: 0 5px;
  font-weight: 400;
}

.card-title {
  color: #404040;
}

.text-muted {
  color: #828282 !important;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

.scroll {
  // max-height: 50vh;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.pr-0 {
  padding-right: 0;
}

.select-all {
  overflow-y: scroll;
}

::v-deep .multiselect__single {
  color: #404040;
  font-weight: 700;
  font-size: 16px !important;
}

.text-des {
  color: #404040;
}

.text-right {
  text-align: right;
}

.table-content {
  height: 50vh;
}

.bg-disabled {
  background: #ffffff !important;
  color: #d3d3d3 !important;
}
</style>
